import React from 'react';

/**
 * <PageHeader title="Properties" subtitle="Your rental portfolio."
 *             actions={<button className="btn-primary">New</button>} />
 */
const PageHeader = ({ title, subtitle, actions, breadcrumb, badge }) => (
    <div className="mb-6 sm:mb-8">
        {breadcrumb && (
            <nav className="text-xs font-medium text-neutral-400 mb-2.5 flex items-center gap-1.5">
                {breadcrumb}
            </nav>
        )}
        <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="min-w-0">
                <div className="flex items-center gap-3">
                    <h1 className="text-2xl sm:text-3xl font-bold text-neutral-900 tracking-tight">{title}</h1>
                    {badge && <div>{badge}</div>}
                </div>
                {subtitle && <p className="text-sm text-neutral-500 mt-1">{subtitle}</p>}
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2.5">{actions}</div>}
        </div>
    </div>
);

export default PageHeader;
